// The activity log's Attachments filter, kept out of TicketConversation.tsx so it can be tested without
// rendering the component.
//
// The field name is written out rather than imported from ACTIVITY_FIELD.FILE_ATTACHMENT because
// shared/utils/constants.tsx imports components (PersonCardOnMention -> mgt), which no test here can load.
// The two must stay equal.
export const FILE_ATTACHMENT_FIELD = 'FileAttachment';

// Dropdown keys whose server-side Property differs from the key. GetActivities matches the Property of the
// stored activity rows, so the value has to be the stored Field - the plural 'FileAttachments' matched nothing.
const FILTER_PROP_BY_KEY: Record<string, string> = {
  Attachments: FILE_ATTACHMENT_FIELD,
  Groups: 'SupportGroup'
};

export const activityFilterProp = (key: string): string => FILTER_PROP_BY_KEY[key] ?? key;

export interface AttachmentActivity {
  Field: string;
  Value?: string;
}

const sentWithComment = (value?: string): boolean => {
  let attachment: any;
  try {
    attachment = JSON.parse(value ?? '');
  } catch {
    return false;
  }
  if (!attachment || typeof attachment !== 'object') return false;
  return Object.hasOwn(attachment, 'Comment') || !!attachment.HasComment;
};

// An attachment sent with a comment is normally drawn inside that comment, so its own FileAttachment row is
// skipped. With the Attachments filter on, the server returns only the FileAttachment rows - the comment is
// not there to draw it - so the row has to be kept or the attachment vanishes from the filtered log.
export const isAttachmentDrawnByComment = (activity: AttachmentActivity, filterProp: string): boolean =>
  activity.Field === FILE_ATTACHMENT_FIELD &&
  filterProp !== FILE_ATTACHMENT_FIELD &&
  sentWithComment(activity.Value);
